import type { StudentCommentResponse } from '@/types/Response/StudentCommentResponse';

const shortComment = 'small lorem ipsum dolor sit amet.';
const mediumComment = `medium lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore
et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea`;
const longComment = `long lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore
    et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea
    commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
    pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est
    laborum.`;
const superLongComment = `extra ${longComment.repeat(10)}`;
const commentsArray = [shortComment, mediumComment, longComment, superLongComment];

export function getMockComments(amount = 2): StudentCommentResponse[] {
    const comments: StudentCommentResponse[] = [];

    for (let i = 0; i < amount; i += 1) {
        comments.push({
            id: i,
            comment: commentsArray[Math.floor(Math.random() * commentsArray.length)],
            createdAt: new Date(),
            adminName: `Test Person ${i}`,
            adminCustomerId: i,
            timeSpent: (-2 + i) * 60,
        });
    }

    return comments;
}
